import { RootState } from "../../../store";
import { ProviderType } from "../../../../services/cloudchipr.api";
import { resourceExplorerStateSelector } from "../resourceExplorerStateSelector";

export const resourceExplorerProvidersSelector = (
  state: RootState,
): ProviderType[] => {
  return resourceExplorerStateSelector(state).providers;
};
